module.exports = __webpack_public_path__ + "static/media/dm.a2be62a6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/dm.svg
// module id = 12
// module chunks = 0